module.exports = __webpack_public_path__ + "img/image96.5351be20.png";